import MapboxDraw from '@mapbox/mapbox-gl-draw';
import * as turf from '@turf/turf';

const CIRCLE_STEPS = 64;

const DirectModeOverride = { ...MapboxDraw.modes.direct_select };

DirectModeOverride.dragFeature = function (state, e, delta) {
  MapboxDraw.modes.direct_select.dragFeature.call(this, state, e, delta);

  if (state.feature.properties.isCircle) {
    const coords = state.feature.getCoordinates()[0];
    if (coords && coords.length > 0) {
      const newCenter = turf.center(turf.polygon([coords])).geometry.coordinates;
      state.feature.properties.center = newCenter;
    }
  }
};

DirectModeOverride.dragVertex = function (state, e, delta) {
  if (state.feature.properties.isCircle) {
    const center = state.feature.properties.center;
    if (!center) return;

    const movedPoint = [e.lngLat.lng, e.lngLat.lat];
    const newRadius = turf.distance(
      turf.point(center),
      turf.point(movedPoint),
      { units: 'kilometers' }
    );

    if (newRadius < 0.01) return;

    const circle = turf.circle(center, newRadius, {
      steps: CIRCLE_STEPS,
      units: 'kilometers'
    });

    state.feature.incomingCoords(circle.geometry.coordinates);
    state.feature.properties.radiusKm = newRadius;
  } else {
    MapboxDraw.modes.direct_select.dragVertex.call(this, state, e, delta);
  }
};

DirectModeOverride.toDisplayFeatures = function (state, geojson, display) {
  if (geojson.properties.user_isCircle) {
    if (geojson.geometry.type === 'Point' && geojson.properties.meta === 'midpoint') {
      return;
    }
    if (geojson.geometry.type === 'Polygon' &&
        (!geojson.geometry.coordinates.length ||
         !geojson.geometry.coordinates[0].length)) {
      return;
    }
  }
  MapboxDraw.modes.direct_select.toDisplayFeatures.call(this, state, geojson, display);
};

export default DirectModeOverride;